import { createContext } from 'react'
import { ErrorBoundary } from '@sentry/react'

import { storeInitialState, zustandStoreKeys } from './storeConstants'
import { ErrorFallback } from '../../components/ErrorFallback/ErrorFallback'
import { errorFallbackComponentsName } from '../../components/ErrorFallback/errorFallbackConstants'
import { capitalizeString } from '../utils'
import { createBaseAppStore } from './storeUtils'

export const StoreContext = createContext()
StoreContext.displayName = 'StoreContext'

export const StoreProvider = ({ config, children }) => {
  const store = createBaseAppStore(config)

  let selectors = {}

  const withSelectors = storeKey => {
    store['use'] = { ...store.use } || {}
    const storeSelectors = {}

    // mixing the store initial values is necessary to avoid an error reading the property
    // if it was deleted (set to undefined) during the update
    for (let key of Object.keys({ ...store.getState()[storeKey], ...storeInitialState[storeKey] })) {
      storeSelectors[key] = () => store(state => state[storeKey][key]) ?? storeInitialState[storeKey][key]
    }

    store.use = { ...store.use, ...storeSelectors }
    store[`useAll${capitalizeString(storeKey)}`] = () => store(state => state[storeKey])

    return store
  }

  zustandStoreKeys.forEach(storeKey => {
    selectors[storeKey] = withSelectors(storeKey)
  })

  return (
    <StoreContext.Provider value={{ store, selectors }}>
      <ErrorBoundary
        beforeCapture={scope => {
          scope.setTag('StoreContext.Provider', 'StoreContext')
        }}
        fallback={fallbackData => (
          <ErrorFallback {...fallbackData} componentName={errorFallbackComponentsName.storeContextProvider} />
        )}
      >
        {children}
      </ErrorBoundary>
    </StoreContext.Provider>
  )
}
